// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-box[data-v-6f79d1e5] {\n  width: 100%;\n}\n.content-box .img[data-v-6f79d1e5] {\n  max-width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
